import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: { id: 'Title', defaultMessage: 'Titolo' },
  titleAlignment: { id: 'Title Alignment', defaultMessage: 'Allineamento del titolo' },
  left: { id: 'Left', defaultMessage: 'Sinistra' },
  center: { id: 'Center', defaultMessage: 'Centro' },
  right: { id: 'Right', defaultMessage: 'Destra' },
  images: { id: 'Images', defaultMessage: 'Immagini' },
  image: { id: 'Image', defaultMessage: 'Immagine' },
  altText: { id: 'Alt Text', defaultMessage: 'Testo alternativo' }, // Nuovo messaggio
});

const photoGallerySchema = (props) => {
  const { intl } = props;

  return {
    title: 'Photo Gallery',
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['title', 'titleAlignment', 'images'],
      },
    ],
    properties: {
      title: {
        title: intl.formatMessage(messages.title),
        type: 'string',
        widget: 'text',
      },
      titleAlignment: {
        title: intl.formatMessage(messages.titleAlignment),
        widget: 'select',
        choices: [
          ['left', intl.formatMessage(messages.left)],
          ['center', intl.formatMessage(messages.center)],
          ['right', intl.formatMessage(messages.right)],
        ],
        default: 'center',
      },
      images: {
        title: intl.formatMessage(messages.images),
        widget: 'object_list',
        schema: {
          title: 'Image',
          fieldsets: [
            {
              id: 'default',
              title: 'Default',
              fields: ['image', 'altText'], // Aggiunto altText
            },
          ],
          properties: {
            image: {
              title: intl.formatMessage(messages.image),
              widget: 'file',
            },
            altText: { // Nuovo campo
              title: intl.formatMessage(messages.altText),
              type: 'string',
              widget: 'text',
              description: 'Testo alternativo per l\'immagine (per accessibilità)',
            },
          },
          required: ['image'], // altText non è obbligatorio
        },
      },
    },
    required: [],
  };
};

export default photoGallerySchema;